import { JobApplication, PaginationResults } from "src/types";
import { get, put } from "../utils";
import { PaginatedJobApplicationParams } from "./type";

export async function getJobsApplicationsPaginated(
  queryParams: PaginatedJobApplicationParams
): Promise<PaginationResults<JobApplication>> {
  return (await get({ path: "outdefine_hire/job_application", queryParams })).body;
}

export async function declineJobApplication(id: number): Promise<JobApplication> {
  return (await put({ path: "outdefine_hire/job_application/decline", body: { id } })).body
    .application;
}
